<template>
	<div class="border-top">
		<SOFilterTitle title="Jenis" :diterapkan="diterapkan" :id="id"/>
		<div class="p-l-24 p-r-24 p-d-24" v-show="false" :id="id">
			<SOInputCheckbox
				:checkboxes="jenisKonsumen"
				:checked="filterItem.jenisKonsumen"
				@selected="selected"
			/>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex"

import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputCheckbox from "@/so-components/global/input/SOInputCheckbox";

export default {
	name: "SOFilterJenisKonsumen",
	components: {
		SOFilterTitle,
		SOInputCheckbox,
	},
	props: {
		id: String,
	},
	computed: {
		...mapGetters("filterGlobalModule", {
			filterItem: "getFilterItem"
		})
	},
	mounted() {
		this.diterapkan = this.filterItem.jenisKonsumen.length > 0
	},
	watch: {
		"filterItem.jenisKonsumen": {
			handler: function () {
				this.diterapkan = this.filterItem.jenisKonsumen.length > 0
			}
		}
	},
	data() {
		return {
			checked: [],
			jenisKonsumen: {
				name: "jenis-konsumen",
				data: [
					{
						id: "fjeniskonsumen-1",
						value: 0,
						title: "Customer Reguler - Non Loyalty",
						checked: false,
						titleBold: false,
					},
					{
						id: "fjeniskonsumen-2",
						value: 1,
						title: "Customer Loyalty Apps",
						checked: false,
						titleBold: false,
					},
				]
			},
			diterapkan: false,
		}
	},
	methods: {
		selected(val) {
			let temp = this.filterItem
			temp.jenisKonsumen = val
			this.$store.commit("filterGlobalModule/setFilterItem", temp)
			this.diterapkan = this.filterItem.jenisKonsumen.length > 0
		}
	}
}
</script>